import { observable } from "mobx";
import { normalize } from "./utils";
import {
  HomeOutlined,
  SettingOutlined,
  TagsOutlined,
  UserOutlined,
  AlignLeftOutlined,
  MehOutlined,
  TeamOutlined,
  SolutionOutlined,
  NotificationOutlined,
  AccountBookOutlined,
} from "@ant-design/icons";

export const gstate = observable({
  //当前访问路径
  pathname: normalize(window.location.pathname),
  loading: false,
  loadingTip: undefined,
  //用户
  user: null,
  perms: {},
  menus: null,
  defaultAvatar:
    "https://cos.chelun.com/static/20251111/a49163d8-8a4b-49fa-b02c-6e83f58cc145_200_200.png",
});

export function setUserInfo(users) {
  gstate.user = users;
  const perms = {};
  (users?.perms || []).forEach((p) => {
    perms[p.value] = true;
  });
  gstate.perms = perms;
}

export function initCommon() {
  gstate.menus = [
    {
      key: "home",
      label: "仪表盘",
      icon: <HomeOutlined />,
      path: "/home",
    },
    {
      key: "banner",
      label: "Banner管理",
      icon: <NotificationOutlined />,
      path: "/banner",
    },
    {
      key: "user",
      label: "用户管理",
      icon: <UserOutlined />,
      path: "/user",
    },
    {
      key: "creatorAudit",
      label: "创作者管理",
      icon: <MehOutlined />,
      path: "/creatorAudit",
    },
    {
      key: "config",
      label: "配置数据",
      icon: <TagsOutlined />,
      path: "/config",
    },
    {
      key: "post",
      label: "发布管理",
      icon: <AlignLeftOutlined />,
      path: "/post",
    },
    {
      key: "order",
      label: "订单管理",
      icon: <AccountBookOutlined />,
      path: "/order",
    },
    {
      key: "admin",
      label: "系统管理",
      icon: <SettingOutlined />,
      children: [
        {
          key: "admin/role",
          label: "角色管理",
          path: "/admin/role",
          icon: <TeamOutlined />,
        },
        {
          key: "admin/account",
          label: "账号管理",
          path: "/admin/account",
          icon: <SolutionOutlined />,
        },
      ],
    },
  ];
}
